import script from "./shareContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./shareContent.vue?vue&type=script&setup=true&lang=ts"

import "./shareContent.vue?vue&type=style&index=0&id=618aba19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618aba19"]])

export default __exports__